import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccountService } from 'src/app/core/services/account.service';
import { SessionTimerService } from '../../../core/services/session-timer.service';
import swal from 'sweetalert2';
import { User } from '../../../core/models/user';
import { lastValueFrom, Subscription, timer } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import { SignalRService } from 'src/app/core/services/signalr.service';
import { startsAndEndsWithValidator } from 'src/app/core/utils/validation-utils';

export interface iSubmitOtp {
    mobileNo: string;
    email: string;
    mobileOTP?: number;
    emailOTP?: number;
    iConfirm: boolean;
    userSource: string;
    checkEligibility: boolean;
}

@Component({
    selector: 'app-assist-submit-otp',
    templateUrl: './assist-submit-otp.component.html',
    styleUrls: ['./assist-submit-otp.component.scss'],
})
export class AssistSubmitOtpComponent implements OnInit, OnDestroy {
    private timerSubscription: Subscription | undefined;

    private timerKey: string = 'otpTimer';

    private tokenStr: string = '';

    private maxTenorPlan: any;

    public partnerAuthToken: any = '';

    @ViewChild('form', { read: NgForm }) form!: NgForm;
    public submitOtp: iSubmitOtp = {
        mobileNo: '',
        email: '',
        iConfirm: false,
        userSource: MemoryStorageService.getItem('userSource') === 'LANDING_PAGE_WIDGET' ? 'LANDING_PAGE_WIDGET' : 'LANDING_PAGE',
        checkEligibility: false
    };

    public resendAvailable: boolean = false;

    public timeRemaining: number = 60;

    public isExpanded = false;

    public isExpandedTandC = false;

    public otpInputConfig = {
        length: 4,
        allowNumbersOnly: true,
        showError: true,
        containerStyles: {
            display: 'flex',
            justifyContent: 'center',
        },
        disableAutoFocus: true,
    }

    public isInCorrectPhoneNumber: boolean = false;

    public isInCorrectPhoneNumberMessage: string = '';

    public alternativeNumberErrorMsg = "";

    public showDialog: boolean = true;

    public alternativeNumberOTP: string = '';

    constructor(
        private accountService: AccountService,
        private router: Router,
        private spinner: NgxSpinnerService,
        private sessionTimerService: SessionTimerService,
        private route: ActivatedRoute,
        private signalRService: SignalRService
    ) { }

    public ngOnDestroy(): void {
        localStorage.removeItem("isAlternativeMobileUpdated");
    }

    public ngOnInit(): void {
        window.scrollTo(0, 0);
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);

        const incomingAgentId = this.route.snapshot.queryParamMap.get('utm_source')
            || this.route.snapshot.queryParamMap.get('regid')
            || this.route.snapshot.queryParamMap.get('regId')
            || this.route.snapshot.queryParamMap.get('RegID')
            || this.route.snapshot.queryParamMap.get('partnerId');
        if (incomingAgentId) {
            const cleanId = incomingAgentId.toString().trim().toUpperCase();
            MemoryStorageService.setItem('travelAgentId', cleanId);
            try { localStorage.setItem('travelAgentId', cleanId); } catch (e) {}
        }

        this.submitOtp.mobileNo = MemoryStorageService.getItem('mobile');
        this.submitOtp.email = MemoryStorageService.getItem('email');
        //this.resumeTimer();
        // For Session Hiding Timer
        this.sessionTimerService.SetShowTimer(false);
        this.sessionTimerService.stopTimer();

        //For OTP Timer
        this.loadTimer();
        this.startTimer();

        if (this.route.snapshot.queryParamMap.get('token') != null) {
            this.accountService.GetTempRequestData(this.route.snapshot.queryParamMap.get('token')?.toString().toUpperCase()).subscribe(
                (res) => {
                    if (res != null && res['data'] != null) {
                        this.submitOtp.mobileNo = res['data'].mobNo;
                        this.submitOtp.email = res['data'].email;
                        this.tokenStr = res['data'].token;
                    }
                    else {
                        return this.router.navigateByUrl('/assist-journey/sorry');
                    }
                });
        };
    }

    public submit() {
        this.spinner.show();
        if (this.tokenStr && this.tokenStr != 'undefined' && this.tokenStr != '') {
            this.partnerAuthToken = this.tokenStr;
        }
        else {
            this.partnerAuthToken = MemoryStorageService.getItem('partnerToken');
        }
        this.submitOtp.emailOTP = Number(this.submitOtp.mobileOTP);
        this.accountService.submitOtp(this.submitOtp, this.partnerAuthToken).subscribe(
            (res) => {
                let isPlanExist = null;
                const isError = res.hasOwnProperty('error') ? (res['error'] != null ? true : false) : false;
                if (!isError) {
                    isPlanExist = res['data'].hasOwnProperty('plan_details');
                }

                //deserialize string response
                if (res['data'] != null && !isPlanExist) {
                    MemoryStorageService.setItem('customerToken', res['data']['sessionId']);
                    const user: User = { token: res['data']['sessionId'], userName: '', email: '', mobileNumber: '' }
                    if (localStorage.getItem("isAlternativeMobileUpdated") !== 'true') {
                        this.signalRService.initSignalR(user.token);
                    }
                    this.accountService.setCurrentUser(user);
                    this.accountService.currentUserSource.pipe(take(1)).subscribe(() => {
                        this.accountService.setMoengageUser(user.token);
                    });
                    const responseMsg = res['data']['response_msg'];
                    //this.sessionTimer();
                    //if(this.isJsonString(responseMsg))
                    if (typeof responseMsg !== 'string') {
                        //let details: any = JSON.parse(res['data']['response_msg']);
                        let details: any = responseMsg;
                        MemoryStorageService.setItem('pan', details['pan']);
                        MemoryStorageService.setItem('pincode', details['pincode']);
                        MemoryStorageService.setItem('dob', details['dob']);
                        MemoryStorageService.setItem('gender', details['gender']);
                        MemoryStorageService.setItem('iConfirm', 'true');
                        this.spinner.hide();
                        return this.router.navigateByUrl('/assist-journey/confirm-details');
                    } else {
                        this.clearMemoryStorageServiceDetails();
                        MemoryStorageService.setItem('iConfirm', 'false');
                        this.spinner.hide();
                        return this.router.navigateByUrl('/assist-journey/confirm-details');
                    }
                }
                else if (res['data'] != null && isPlanExist) {
                    const plandetails = res['data']['plan_details'];
                    const creditscore = res['data'].creditScore;
                    MemoryStorageService.setItem('creditscore', creditscore);
                    MemoryStorageService.setItem('approvalAmount', res['data']['availableLimit'])
                    // min amount to be 10000 - min for lender (Monedo is the lowest)
                    if (this.checkPlanEligibility(plandetails) && +res['data']['availableLimit'] < 10000) {
                        return this.router.navigateByUrl('/assist-journey/assist-underwrite');
                    }

                    //starting the Session Timer
                    this.restartTimer();
                    //this.sessionTimer();

                    // Setting SessionId to be used on Session Expire Page for updating the apllication Status 
                    const user: User = { token: res['data']['sessionid'], userName: '', email: '', mobileNumber: '' }
                    MemoryStorageService.setItem('customerToken', res['data']['sessionid']);
                    if (localStorage.getItem("isAlternativeMobileUpdated") !== 'true') {
                        this.signalRService.initSignalR(user.token);
                    }
                    this.accountService.setCurrentUser(user);
                    this.accountService.currentUserSource.pipe(take(1)).subscribe(() => {
                        this.accountService.setMoengageUser(user.token);
                    });
                    //////


                    //Setting if Available Limit has exhausted 
                    // const travelcost = parseInt(MemoryStorageService.getItem('TravelCost'));
                    // const availableLimit = parseInt(res['data']['availableLimit']);

                    //  MemoryStorageService.setItem('hasLimitExhausted', travelcost > availableLimit ? "true": "false")
                    //////

                    /*** skip the plan page with selecting max tenure for Consolidator INDCR00173 (now updated for all the landing page users) (TaskId 1073) ***/
                    // if ((MemoryStorageService.getItem("userSource") === 'LANDING_PAGE' || MemoryStorageService.getItem("userSource") === 'LANDING_PAGE_WIDGET') && res['data'].isFinalPlan !== true) {
                    //     MemoryStorageService.setItem('assistTravelPlans', JSON.stringify(plandetails));
                    //     this.maxTenorPlan = res['data'].plan_details.reduce((max, plan) => {
                    //         return (plan.tenor > max.tenor) ? plan : max;
                    //     });
                    //     return this.router.navigateByUrl(
                    //         '/assist-journey/' + this.maxTenorPlan.navigate_url.split('/')[4]
                    //     );
                    // }
                    // else
                    if (res['data'].isFinalPlan === true) {
                        MemoryStorageService.setItem('assistTravelPlans', JSON.stringify(plandetails));
                        this.spinner.hide();
                        return this.router.navigateByUrl('/assist-journey/assist-payment-plan-repeat');
                    }
                    /********************/

                    //check plans
                    if (plandetails != null) {
                        MemoryStorageService.setItem('assistTravelPlans', JSON.stringify(plandetails));
                        this.spinner.hide();
                        //this.router.navigateByUrl('/assist-journey/payment-plans');
                        this.router.navigateByUrl('/assist-journey/lender-selection');
                    }
                }
                else if (isError && (res['error'].response_summary == "User is declined" || res['error'].response_msg.includes('not eligible'))) {
                    swal.fire(res['error']['response_msg']);
                    this.spinner.hide();
                    return this.router.navigateByUrl('/assist-journey/sorry');
                }
                else if (isError && (res['error'].response_summary == "Pan matched with existing user")) {
                    swal.fire(res['error']['response_msg']);
                    this.spinner.hide();
                }
                else if (isError && res['error'].response_summary == "In process" && res['error'].response_msg == "Your loan application is in review by our team of experts.") {
                    this.spinner.hide();
                    return this.router.navigateByUrl('/assist-journey/assist-underwrite');
                }
                else if (isError && (res['error'].response_msg == "Wrong OTP entered thrice. Please generate new OTP." || res['error'].response_msg == "OTP is incorrect, please try again")) {
                    swal.fire(res['error']['response_msg']);
                    this.spinner.hide();
                }
                else {
                    this.spinner.hide();
                    //MemoryStorageService.setItem('isStartTimer','false');
                    //swal.fire(res['error']['response_msg']);
                    return this.router.navigateByUrl('/assist-journey/assist-processing');
                }
            },
            (error) => {
                this.spinner.hide();

                if (error.status === 0) {
                    swal.fire("No internet connection. Please check your network and try again.");
                    return;
                }

                if (error && error.error.errors) {
                    console.log(error.error.errors, "errors");
                    const { message, token } = error.error.errors;
                    if (message.includes('Please provide mobile ending with')) {
                        this.isInCorrectPhoneNumber = true;
                        this.showDialog = true;
                        this.isInCorrectPhoneNumberMessage = message;
                        MemoryStorageService.setItem('customerToken', token);
                    }
                    return;
                } else {
                    return this.router.navigateByUrl('/assist-journey/assist-processing');
                }
                //swal.fire('Unhandled error occured, please try again later.');
            }
        );
    }

    public handleLabelKeydown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.submitOtp.iConfirm = !this.submitOtp.iConfirm;
        }
    }

    public checkPlanEligibility(plans: any[]) {
        const hasEligiblePlan = plans.some(plan => plan.plan_eligibility);
        return !hasEligiblePlan
    }

    public shouldShowValidation(formControl: NgModel) {
        return (
            formControl &&
            formControl.invalid &&
            (formControl.dirty || this.form.submitted)
        );
    }

    public toggleReadMore() {
        this.isExpanded = !this.isExpanded;
    }

    public toggleTandC() {
        this.isExpandedTandC = !this.isExpandedTandC;
    }

    private clearMemoryStorageServiceDetails(): void {
        MemoryStorageService.removeItem('pan');
        MemoryStorageService.removeItem('pincode');
        MemoryStorageService.removeItem('dob');
        MemoryStorageService.removeItem('gender');
        MemoryStorageService.removeItem('iConfirm');
    }

    public allowOnly(event: KeyboardEvent, type: string): void {
        const char = event.key;
        if (type === 'numbers' && !char.match(/[0-9]/)) {
            event.preventDefault();
        }
        if (type === 'alphabets' && !char.match(/[a-zA-Z]/)) {
            event.preventDefault();
        }
    }

    /* Session Timer */
    public sessionTimer(): void {
        this.sessionTimerService.SetShowTimer(true);
        this.sessionTimerService.startTimer();
    }

    public restartTimer(): void {
        this.sessionTimerService.SetShowTimer(true);
        this.sessionTimerService.restartTimer();
    }
    /* End - Session Timer */

    /* OTP Timer */
    public startTimer(): void {
        const now = new Date().getTime();
        const savedExpiryTime = MemoryStorageService.getItem(this.timerKey);
        if (savedExpiryTime) {
            const expiryTime = parseInt(savedExpiryTime, 10);
            this.timeRemaining = Math.max(Math.floor((expiryTime - now) / 1000), 0);
            this.resendAvailable = this.timeRemaining === 0;
        }
        this.timerSubscription = timer(0, 1000).pipe(switchMap(() => {
            if (this.timeRemaining > 0) {
                this.timeRemaining--;
                this.saveTimer();
                return [this.timeRemaining];
            } else {
                this.resendAvailable = true;
                MemoryStorageService.removeItem(this.timerKey);
                if (this.timerSubscription) {
                    this.timerSubscription.unsubscribe();
                }
                return [];
            }
        })).subscribe();
    }

    public saveTimer(): void {
        const expiryTime = new Date().getTime() + (this.timeRemaining * 1000);
        MemoryStorageService.setItem(this.timerKey, expiryTime.toString());
    }

    public loadTimer(): void {
        const savedExpiryTime = MemoryStorageService.getItem(this.timerKey);
        if (savedExpiryTime) {
            const now = new Date().getTime();
            const expiryTime = parseInt(savedExpiryTime, 10);
            this.timeRemaining = Math.max(Math.floor((expiryTime - now) / 1000), 0);
            this.resendAvailable = this.timeRemaining === 0;
        }
    }

    public resendOtp(): void {
        this.timeRemaining = 60;
        this.saveTimer();
        this.resendAvailable = false;
        this.startTimer();
        this.accountService.resendOTPMobile(this.submitOtp.mobileNo, MemoryStorageService.getItem('partnerToken')).subscribe(
            (res) => {
                if (res['data'] != null && res['data']['response_summary'] != null) {
                    swal.fire(res['data']['response_summary']);
                }
                else if (res['error'] != null && res['error']['response_summary'] == "Max 5 OTP can be send on 15min interval") {
                    MemoryStorageService.removeItem(this.timerKey);
                    if (this.timerSubscription) {
                        this.timerSubscription.unsubscribe();
                    }
                    this.timeRemaining = 60 * 15;
                    this.saveTimer();
                    this.resendAvailable = false;
                    this.startTimer();
                    swal.fire(res['error']['response_summary']);
                }
                else {
                    swal.fire(res['error']['response_summary']);
                }
            },
            (error) => {
                this.spinner.hide();
                //swal.fire('Unhandled error occured, please try again later.');
            }
        );
    }

    /* End - OTP Timer */
    public async onChangeAlternativeInput(event: Event) {
        const alterNativeNumber = (event.target as HTMLInputElement).value;

        const arr = this.isInCorrectPhoneNumberMessage.split(' ');

        const numberInMessage = arr[arr.length - 1];

        const isValid = startsAndEndsWithValidator(numberInMessage, alterNativeNumber);

        if (!isValid) {
            this.alternativeNumberErrorMsg = 'Entered Number is matched with the suggsted.';
        } else {
            this.alternativeNumberErrorMsg = '';
            MemoryStorageService.setItem("AlternateMobileNo", alterNativeNumber)
        }
    }

    public async sendAlternativeOTP() {
        const token = MemoryStorageService.getItem('customerToken');
        const alterNativeNumber = MemoryStorageService.getItem('AlternateMobileNo');
        const res = await lastValueFrom(this.accountService.GetOTPForAlternativeNumber(alterNativeNumber, token));
        if (res['error'] == null && res['data'] == 'OTP Sent successfully on given mobile number.') {
            this.showDialog = false;
            swal.fire("OTP Sent successfully");
            this.spinner.hide();
            return;
        }
        swal.fire("Could not send OTP! Please try again.");
    }

    public async confirmNewNumber() {
        try {
            this.spinner.show();
            const token = MemoryStorageService.getItem('customerToken');
            const mobileNo = MemoryStorageService.getItem("AlternateMobileNo");
            const oldNumber = MemoryStorageService.getItem('mobile');
            this.submitOtp.mobileNo = mobileNo;
            this.submitOtp.mobileOTP = parseInt(this.alternativeNumberOTP);
            const res = await lastValueFrom(this.accountService.UpdateAlternetNumberNew(mobileNo, this.alternativeNumberOTP, oldNumber, token));
            if (res['error'] == null) {
                this.spinner.hide();
                localStorage.setItem("isAlternativeMobileUpdated", "true");
                await this.submit();
                return;
            }
            else if (
                res['error'] != null &&
                res['error'].response_summary == 'OTP provided is incorrect'
            ) {
                swal.fire("OTP provided is incorrect");
            }
            else if (
                res['error'] != null &&
                res['error'].response_msg == 'Wrong OTP entered thrice. Please generate new OTP.'
            ) {
                swal.fire("Wrong OTP entered thrice, Please generate new OTP!");
            }
            else {
                swal.fire("Unable to update mobile number");
            }
        }
        catch (err) {
            console.log(err);
        }
        this.spinner.hide();
        this.isInCorrectPhoneNumber = false;
    }
}
